import "./Guideline.scss";
import { Badge, Popover, Typography } from "antd";

export default function Guideline({
  token,
  children,
  title = "",
  trigger = "click",
  content = "",
  listItems = [],
  description = "",
  overlayClassName = "",
}) {
  const defaultContent = () => {
    return (
      <div>
        <Typography.Text className="guideLine-cont__boldText">
          {description || ""}
        </Typography.Text>
        <div className="guideLine-cont__list">
          {(Array?.isArray(listItems) && listItems?.length
            ? listItems
            : []
          ).map((item, index) => (
            <div
              key={index}
              className="guideLine-cont__list__listItem">
              <Badge dot color={token?.colorText || "black"}></Badge>
              <div
                className="guideLine-cont__rowWrapper"
                style={{
                  width: `calc(100% - 6px - 8px)`,
                }}>
                <Typography.Text
                  className="guideLine-cont__boldText"
                  ellipsis={{
                    tooltip: {
                      title: `${item || ""}`,
                    },
                  }}>
                  {item || ""}
                </Typography.Text>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  };

  return (
    <Popover
      rootClassName="guideLine-cont"
      destroyOnHidden={true}
      title={
        <Typography.Text className="guideLine-cont__title">
          {title || ""}
        </Typography.Text>
      }
      trigger={trigger}
      content={content ? content : defaultContent}
      okButtonProps={{
        size: "small",
      }}
      overlayClassName={overlayClassName || "guideLine-cont__overlay"}>
      {children}
    </Popover>
  );
}
